import React from 'react';
import { Header, Icon, Segment } from 'semantic-ui-react';
import SidebarWithFixedPusher from '../../../components/SidebarWithFixedPusher';
import { getOrderItemsCountDisplay } from '../../../services/checkout';
import { CurrencyNumberPropType } from '../../../services/proptypes';
import { classNames } from '../../../utils/classname';
import { formatCurrency } from '../../../utils/currency';
import CartSummary from '../CartSummary';
import { CartPropType } from '../CartSummary/CartSummary.propTypes';
import './CartSummaryTray.css';
var defaultProps = {
  show: undefined,
  defaultShow: false,
  displayHeaderActions: false,
  readOnly: false,
  onShow: null,
  onUpdateCartItemQuantity: function onUpdateCartItemQuantity() {
    return null;
  },
  onDeleteCartItem: function onDeleteCartItem() {
    return null;
  },
  onUpdateCartItem: function onUpdateCartItem() {
    return null;
  },
  onSpecialInstructionsChange: function onSpecialInstructionsChange() {
    return null;
  },
  getOrderItemOptions: null,
  loading: false,
  tip: '0.00',
  onTipChange: null,
  fixedCartTotals: true,
  children: null
};
function CartSummaryTray(_ref) {
  var cart = _ref.cart,
    onUpdateCartItemQuantity = _ref.onUpdateCartItemQuantity,
    onUpdateCartItem = _ref.onUpdateCartItem,
    onDeleteCartItem = _ref.onDeleteCartItem,
    onSpecialInstructionsChange = _ref.onSpecialInstructionsChange,
    getOrderItemOptions = _ref.getOrderItemOptions,
    displayHeaderActions = _ref.displayHeaderActions,
    readOnly = _ref.readOnly,
    loading = _ref.loading,
    onShow = _ref.onShow,
    defaultShow = _ref.defaultShow,
    show = _ref.show,
    tip = _ref.tip,
    onTipChange = _ref.onTipChange,
    fixedCartTotals = _ref.fixedCartTotals,
    children = _ref.children;
  var itemsCountDisplay = getOrderItemsCountDisplay(cart).toUpperCase();
  var _cart$total = cart.total,
    total = _cart$total === void 0 ? 0 : _cart$total;
  function getPusherContent() {
    return /*#__PURE__*/React.createElement(Segment, {
      className: "pusher-content"
    }, /*#__PURE__*/React.createElement("p", null, itemsCountDisplay), /*#__PURE__*/React.createElement("p", null, formatCurrency(total), " ", /*#__PURE__*/React.createElement(Icon, {
      size: "large",
      name: "angle up"
    })));
  }
  return /*#__PURE__*/React.createElement(SidebarWithFixedPusher, {
    className: classNames({
      'cart-summary-tray': true,
      'fixed-cart-totals': fixedCartTotals
    }),
    pusherContent: getPusherContent(),
    show: show,
    onShow: onShow,
    defaultShow: defaultShow
  }, function (_ref2) {
    var hideSidebar = _ref2.hideSidebar;
    return /*#__PURE__*/React.createElement(CartSummary, {
      header: /*#__PURE__*/React.createElement(Header, {
        className: "cart-summary-tray-header",
        as: "h3"
      }, /*#__PURE__*/React.createElement(Header.Content, null, itemsCountDisplay, " IN CART"), /*#__PURE__*/React.createElement(Icon, {
        name: "angle down",
        onClick: hideSidebar
      })),
      cart: cart,
      onDeleteCartItem: onDeleteCartItem,
      onUpdateCartItemQuantity: onUpdateCartItemQuantity,
      onUpdateCartItem: onUpdateCartItem,
      getOrderItemOptions: getOrderItemOptions,
      loading: loading,
      tip: tip,
      onTipChange: onTipChange,
      readOnly: readOnly,
      displayHeaderActions: displayHeaderActions,
      onSpecialInstructionsChange: onSpecialInstructionsChange
    }, children);
  });
}
CartSummaryTray.defaultProps = defaultProps;
export default CartSummaryTray;